<template>
    <!-- 全景引导 -->
   <div class="vrhome">
           <!-- 封面 begin-->
           <div class="vrBoxFm wrap"  v-show="pageState=='beginLoad'">
               <div class="pagebjbox pos_abs"></div>
                <!-- <div id="pano_home" class="vrbox " style="width:100%;height:100vh; z-index: 99999">
                  <noscript><table style="width:100%;height:100%;"><tr style="vertical-align:middle;text-align:center;"><td>ERROR:<br><br>Javascript not activated<br><br></td></tr></table></noscript>
                </div> -->
               <!-- <img src="../assets/images/page1_logo.png" class="pos_abs vrfmlogo animated fadeInDown"> -->
               <div class="btnbox">
                   <!-- <img src="../assets/images/page1_slog.png" class="page1slog pos_abs animated fadeInUp">
                   <img src="../assets/images/page1_icon.png" class="page1_icon pos_abs animated zoomIn">
                   <img src="../assets/images/page1_txt.png" class="page1_txt pos_abs animated fadeInUp"> -->
                   <img src="http://219.153.58.123:8080/car/fuyu_al/lengsuanling/page1_slog.png" class="page1slog pos_abs animated fadeInUp">
                   <img src="http://219.153.58.123:8080/car/fuyu_al/lengsuanling/page1_icon.png" class="page1_icon pos_abs animated zoomIn">
                   <img src="http://219.153.58.123:8080/car/fuyu_al/lengsuanling/page1_txt.png" class="page1_txt pos_abs animated fadeInUp">
                   <img src="http://219.153.58.123:8080/car/fuyu_al/lengsuanling/page1_btn.png" class="page1btn pos_abs animated bounceIn" @click="showtips">
               </div>
           </div>
           <!-- 封面 end-->

           <!-- 提示 begin-->
           <div class="outsideBox" >
             <div class="topbox gameTips wrap" v-show="pageState=='showtips'">
                 <!-- <img src="../assets/images/game_gz_txt.png" class=" game_gz animated fadeInUp"> -->
                 <img src="http://219.153.58.123:8080/car/fuyu_al/lengsuanling/game_gz_txt.png" class=" game_gz animated fadeInUp">
                 <img src="../assets/images/btn_into.png" class=" btn_into animated zoomIn" @click="closeTips">
             </div>
           </div>
           <!-- 提示 end-->
   </div>

    <!-- 全景引导 -->
</template>

<style type="text/css">
.gameTips{background: url('../assets/images/page1_bj.jpg')!important;flex-wrap: wrap;
    flex-direction: column;}
.page1_txt{width: 3.86rem;
    height: 0.66rem;
    margin-top: 3.0rem;
    animation-delay: 0.5s;
    -webkit-animation-delay: 0.5s;}
.pos_abs{ position: absolute; }
.page1_icon{    width: 6.92rem;
    /* height: 6.42rem; */
    margin-top: 1.49rem;
    animation-delay: 0.3s;
    -webkit-animation-delay: 0.3s;}
    .page1slog{      width: 5.67rem;
    margin-top: -3.5rem;
    animation-delay: 0.1s;
    -webkit-animation-delay: 0.1s;}
    .page1btn{        width: 4.44rem;
       margin-top: 4.1rem;
    height: 0.85rem;animation-delay: 1.0s;-webkit-animation-delay: 1.0s;}

.vrBoxFm{ position: fixed;top:0px; left:0px;  z-index: 999999}
 .vrloading{ display: flex; justify-content: center; align-items: center; font-size: 0.28rem; }
.loadingOutside{    width: 70%;
    height: 0.16rem;
    border-radius: 0.5rem;
    /* background-color: #fff;  */}
.loadingOutside  p{    text-align: center;
    padding-top: 0.1rem;}

/* .loadingOked {    width: 0%;
    height: 0.16rem;
    background-color: #098b8e;
    border-radius: 0.5rem;} */
    .vrfmbj{ width: 7.5rem;    height: 100%; }
    .pos_abs{ position: absolute; z-index: 5 }
    .vrfmlogo{ width: 2.62rem;    top: 0.3rem;
    left: 0.2rem; }
    .page1_btn{     width: 2.21rem;
    height: 0.55rem;
    top: 5.3rem;
    left: 2.8rem; animation-delay: .5s; -webkit-animation-delay: .5s; }
    .page1_slog{ width: 6.84rem;top: 2.7rem;left: 0.7rem;}
    .game_gz{     width: 6.82rem;
    height: 11.07rem;
    margin-left: -0.38rem;
    margin-top: -0.8rem;animation-delay: .1s; -webkit-animation-delay: .1s; animation-duration: 0.6s; -webkit-animation-duration: 0.6s;}
    .outsideBox{     position: relative;
    width: 7.5rem;
    margin: 0 auto; }
    .btn_into{width: 4.44rem;animation-delay: 0.4s;-webkit-animation-delay: 0.4s;
    height: 0.85rem;    margin-top: -0.55rem;}
    .gameTips p{         width: 4.5rem;
    max-height: 2rem;
    margin: 0 auto;
    font-size: 0.32rem;
    top: 3rem;
    line-height: 0.6rem;
    text-indent: 2em;
    color: #fff;
    position: absolute;}
    .pagebjbox{ width:100%; height: 100vh; background: url('http://219.153.58.123:8080/car/fuyu_al/lengsuanling/page1_bj2.jpg'); 
      opacity: 0.85; background-size: cover; z-index: 3 }
      .btnbox{ width: 100%; height: 100vh; display: flex; justify-content: center; align-items: center; position: fixed; top:0; left:0; flex-direction: column;
    z-index: 99;} 
 /*    .btnbox img{ margin-top:0.4rem; } */
  @media screen and (max-width: 375px) {
    .page1slog {
    margin-top: -3.15rem;
    }
  } 
</style>

<script type="text/javascript">
import globalVar from '@/api/global_variable'
	export default{
		name:'homevr',
		props:[],
		data(){
			return {
                  isLoadOk:true,
                  pageState:'beginLoad',
                  getUrlPar:{
                    gettype:0,
                    typeid:1,
                    page:1,
                    size:5
                  },
                  pageNum:0,
                  loading: false,
                  finished: false,
                  nowTime:parseInt(new Date().getTime()/1000),
                  isshow:true,
			}
		},
		mounted (){
          //this.loadPano();
		},
		methods:{
                    loadPano(){
                       embedpano({swf:"./static/pano/krpano.swf", 
                        xml:"./static/pano/pageNone.xml",   
                        target : "pano_home", 
                        consolelog : false,          // trace krpano messages also to the browser console
                        passQueryParameters : false});
                     },
                    share(){
                        let shareDataObj={
                        　　　　title: '', // 分享标题
                        　　　　desc: '', // 分享描述
                        　　　　link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        　　　　imgUrl: '', // 分享图标
                                success: function () {          
                                  console.log("调用分享接口成功");
                         　　　 }
                        }
                        //this.Share.wx(shareDataObj)
                    },
                    showtips(){
                      let isPc=globalVar.isPc();
                      if(isPc){
                         this.closeTips();
                      }else{
                        this.pageState="showtips"
                      }
                    },
                    closeTips(){
                      //关闭提示
                      //this.pageState='showPano'
                       //this.$router.push({ path: '/Vrbox'});
                       vrComponents.isfirstInto=false;
                    }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/Homevr.vue